<div
  class="dynamic-field form-input"
  [ngClass]="[
    config.name + '-container',
    this.fieldControl.invalid ? 'dynamic-field--invalid' : '',
    isRequired ? 'dynamic-field--required' : '',
    visible ? 'd-block' : 'd-none'
  ]"
  [formGroup]="group"
>
  <cwc-input
    [readonly]="config?.readonly"
    [label]="config.label | translate"
    [placeholder]="placeholder | translate"
    [status]="config.updateStatusMnaually
      ? shouldShowError ? 'error' : 'regular'
      : (fieldControl.invalid && !fieldControl.untouched ? 'error' : 'regular')"
    [formControlName]="config.name"
    [required]="isRequired"
    [disabled]="isInformative"
    [attr.data-test]="config?.dataTId"
    [attr.data-tid]="config?.dataTId"
    [attr.data-name]="config?.name"
    [rtl]="rtl"
    [maxlength]="config['maxlength']"
    [statusMessage]="(showMessage$ | async) | translate
    "
    designVersion="v2"
  ></cwc-input>
</div>
